import * as Scrivito from "scrivito";
import LinkTitle from "^/utils/LinkTitle";
import { useMobileNavigation } from "^/Context/MobileNavigationContext";
import SideIcon from "./SideIcon";

function LinkList({
  elems,
  className,
  classNameLink,
  iconSide,
  currentPage,
  level,
}) {
  return (
    <ul className="list-unstyled">
      {elems.map((item, index) => (
        <LinkListItem
          key={index}
          target={item}
          iconSide={iconSide}
          className={className}
          linkClassNames={classNameLink}
          currentPage={currentPage}
          level={level}
        />
      ))}
    </ul>
  );
}

const LinkItem = Scrivito.connect(({ target, className, iconSide, level }) => {
  const { dispatch } = useMobileNavigation();
  const navOnly = target.get("isNavigationPage") === "yes";
  const url = navOnly ? "#" : Scrivito.urlFor(target);
  return (
    <a
      href={url}
      className={`w-100 p-3 d-block ${className}`}
      onClick={() => {
        if (navOnly) {
          dispatch({
            type: "updateCurrentPageId",
            payload: {
              pageId: target.id(),
              navLevel: parseInt(level, 10) + 1,
            },
          });
        }
      }}
    >
      <LinkTitle link={target} />
      <SideIcon iconSide={iconSide} />
    </a>
  );
});

const LinkListItem = Scrivito.connect(
  ({ target, className, linkClassNames, iconSide, level }) => (
    <li className={className}>
      <LinkItem
        target={target}
        className={linkClassNames}
        iconSide={iconSide}
        level={level}
      />
    </li>
  )
);

export default Scrivito.connect(LinkList);
